




















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import SegmentControls from '@/components/SegmentControls.vue';
import Tags from '@/components/Tags.vue';
import NumberPad from '@/components/NumberPad.vue';
import defaultRecordList from '@/constants/defaultRecordList';
import {DatePicker} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import {Moment} from 'moment';
import Icon from '@/components/Icon.vue';
import dayjs from 'dayjs';

Vue.component(DatePicker.name, DatePicker);

@Component({
  components: {Icon, NumberPad, Tags, SegmentControls}
})
export default class Money extends Vue {
  record = defaultRecordList;
  time = '';
  today = new Date().toISOString();

  get recordList() {
    return this.$store.state.recordList as RecordItem[];
  }

  created() {
    this.$store.commit('fetchRecords');
    this.record.createdAt = this.today;
  }

  destroyed() {
    this.record.amount = 0;
  }

  get beautify() {
    return dayjs(this.today).format('YYYY-MM-DD');
  }

  onChange(date: Moment | string, dateString: string) {
    this.time = new Date(dateString).toISOString();
    this.record.createdAt = this.time;
    this.time = dateString;
  }

  saveRecord(value: number) {
    this.record.amount = value;
    try {
      this.$store.commit('createRecord', this.record);
    } catch (error) {
      if (error.message === 'icon empty') {
        window.alert('分类图标不能为空！');
      }
    }
  }

}
